<template>
  <section class="account-com">
    <nut-dialog :title="title" :noFooter="true" :visible="showLogin" :closeOnClickModal="false">
      <nut-textinput
        v-model="phoneNumber"
        label="手机号："
        placeholder="请输入手机号"
        :clearBtn="false"
        :disabled="false"
      />
      <nut-textinput v-if="type==='register'"
        v-model="userName"
        label="用户名："
        type="userName"
        placeholder="请输入用户名"
        :clearBtn="false"
        :disabled="false"
      />
      <div style="display: flex; padding-right: 20px;">
        <nut-textinput id="codeLine" v-if="type==='register'" style="width: calc(100% - 80px)!important; padding-right: 0!important;"
          v-model="code"
          label="验证码："
          type="code"
          placeholder="请输入验证码"
          :clearBtn="false"
          :disabled="false"
        />
        <div v-if="type==='register'" style="margin: 20px 0 0">
          <div class="getcode" style="width: 80px!important;">
            <el-button v-if="!countDown" style="width: 80px;" type="primary" plain :loading="codeLoadingFlag" @click="getCode()">获取</el-button>
            <el-button v-else style="width: 80px;" type="primary" plain :loading="codeLoadingFlag" @click="getCode()" disabled>{{countDown}}s</el-button>
          </div>
        </div>
      </div>
      <div style="display: flex; padding-right: 20px;">
        <nut-textinput id="codeLine" v-if="type==='password'" style="width: calc(100% - 80px)!important; padding-right: 0!important;"
          v-model="code"
          label="验证码："
          type="code"
          placeholder="请输入验证码"
          :clearBtn="false"
          :disabled="false"
        />
        <div v-if="type==='password'" style="margin: 20px 0 0">
          <div class="getcode" style="width: 80px!important;">
            <el-button v-if="!countDown" style="width: 80px;" type="primary" plain :loading="codeLoadingFlag" @click="getCode()">获取</el-button>
            <el-button v-else style="width: 80px;" type="primary" plain :loading="codeLoadingFlag" @click="getCode()" disabled>{{countDown}}s</el-button>
          </div>
        </div>
      </div>
      <div v-if="type==='password'" style="margin: 20px 0 0">
        <nut-textinput
          v-model="password"
          label="新密码："
          type="password"
          placeholder="请输入新密码"
          :clearBtn="false"
          :disabled="false"
        />
      </div>
      <!-- <nut-textinput v-if="type==='register'"
        v-model="invietCode"
        label="邀请码："
        type="invietCode"
        placeholder="请输入邀请码"
        :clearBtn="false"
        :disabled="false"
      /> -->
      <div v-if="type!=='password'" style="margin: 20px 0 0">
        <nut-textinput
          v-model="password"
          label="密码："
          type="password"
          placeholder="请输入密码"
          :clearBtn="false"
          :disabled="false"
        />
      </div>
      <!-- <nut-textinput
        v-model="password"
        label="密码"
        placeholder="请输入密码"
        :clearBtn="false"
        :disabled="false"
      /> -->
      <div class="register" v-if="type==='login'">
        没有账号？<u @click="type='register', title='注册'">去注册。</u>忘记密码？<u @click="type='password', title='重设密码'">去找回</u>
      </div>
      <div class="action" v-if="type==='login'">
        <span class="login" @click="handleLogin()">登录</span>
        <!-- <span class="login" @click="checkLogin()">登录</span> -->
      </div>
      <div class="register-tips" v-if="type==='register'">
        tips:若您注册时出现问题，请拨打热线电话:18268767761!!
      </div>
      <div class="register" v-if="type==='register'">
        已有账号？<u @click="type='login', title='登录'">去登录</u>
      </div>
      <div class="register-tips" v-if="type==='password'">
        tips:若您重设密码时出现问题，请拨打热线电话:18268767761!!
      </div>
      <div class="register" v-if="type==='password'">
        <u @click="type='login', title='取消重设'">取消重设</u>
      </div>
      <div class="action" v-if="type==='register'">
        <span class="login" @click="doRegister()">注册</span>
      </div>
      <div class="action" v-if="type==='password'">
        <span class="login" @click="passwordNew()">重设密码</span>
      </div>
      <i class="icon-close iconfont" @click="$emit('update:showLogin', false)"></i>
    </nut-dialog>
  </section>
</template>

<script src="https://turing.captcha.qcloud.com/TCaptcha.js"></script>
<script>
import api from '../../../api/index'
export default {
  props: ['showLogin'],
  data () {
    return {
      type: 'register', // 'login', 'register'
      title: '登录', // '登录', '注册'
      phoneNumber: '',
      userName: '',
      code: '',
      invietCode: '',
      password: '',
      countDown: 0,
      codeLoadingFlag: false
    }
  },
  mounted () {
  },
  methods: {
    checkLogin () {
      if (!this.phoneNumber || !this.password) {
        this.$toast.text('请输入手机号和密码')
        return
      }
      this.loading = this.$toast.loading()
      api.loginCheck({
        phoneNumber: this.phoneNumber,
        password: this.password
      }).then(res => {
        this.loading.hide()
        if (res.code === 200) {
          this.loginCaptcha()
        } else {
          this.$toast.text(res.message || '登录失败，请稍后再试')
        }
      })
    },
    loginCaptcha () {
      var loadErrorCallback = () => {
        var appid = '196384447'
        // 生成容灾票据或自行做其它处理
        var ticket = 'trerror_1001_' + appid + Math.floor(new Date().getTime() / 1000)
        this.callback({
          ret: 0,
          randstr: '@'+ Math.random().toString(36).substr(2),
          ticket:ticket,
          errorCode: 1001,
          errorMessage: 'jsload_error',
        })
      }
      try {
        // 生成一个验证码对象
        var captcha = new TencentCaptcha('196384447', this.callback, {})
        // 调用方法，显示验证码
        captcha.show()
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        console.log('error', error)
        loadErrorCallback()
      }
    },
    callback (res) {
      console.log('callback', res)
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求错误，返回trerror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      if (res.ticket) {
        // 根据errorCode情况做特殊处理
        if (res.errorCode) {
          // 自定义容灾逻辑（例如跳过这次验证）
          this.$toast.text('验证失败，请稍后再试')
          return
        }
        api.publicityCode(res).then(res2 => {
          if (res2.code === 200) {
            this.handleLogin()
          } else {
            this.$toast.text('验证失败，请稍后再试')
          }
        })
      }
    },
    handleLogin () {
      if (!this.phoneNumber || !this.password) {
        this.$toast.text('请输入手机号和密码')
        return
      }
      this.loading = this.$toast.loading()
      api.login({
        phoneNumber: this.phoneNumber,
        password: this.password
      }).then(res => {
        this.loading.hide()
        if (res.code === 200) {
          console.log(res.data)
          sessionStorage.setItem('qs_phone', this.phoneNumber)
          sessionStorage.setItem('qs_token', res.data.token)
          sessionStorage.setItem('qs_user_name', res.data.name)
          this.$emit('dispatchUserName', res.data.name)
          this.$emit('update:showLogin', false)
          window.location.reload()
        } else {
          this.$toast.text(res.message || '登录失败，请稍后再试')
        }
      })
    },
    getCode () {
      if (!/^1[3456789]\d{9}$/.test(this.phoneNumber)) {
        this.$toast.text('请输入正确的手机号')
        return
      }
      this.codeLoadingFlag = true
      api.getPhoneCode({
        phoneNumber: this.phoneNumber
      }).then(res => {
        this.codeLoadingFlag = false
        if (res.code === 200) {
          this.countDown = 60
          this.startCountDown()
        } else {
          this.$toast.text(res.message || '获取验证码失败，请稍候再试')
        }
      })
    },
    startCountDown () {
      this.timer = setInterval(() => {
        this.countDown--
        if (!this.countDown) clearInterval(this.timer)
      }, 1000)
    },
    doRegister (e) {
      if (!this.userName || !this.password) {
        this.$toast.text('请输入用户名和密码')
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.phoneNumber)) {
        this.$toast.text('请输入正确的手机号')
        return
      }
      if (!this.code) {
        this.$toast.text('请输入手机验证码')
        return
      }
      this.registerLoadingFlag = true
      api.register({
        userName: this.userName,
        phoneNumber: this.phoneNumber,
        password: this.password,
        code: this.code,
        invitation: this.invietCode || undefined
      }).then(res => {
        this.registerLoadingFlag = false
        if (res.code === 200) {
          this.$toast.text('注册成功')
          this.type = 'login'
        } else {
          this.$toast.text(res.message || '登录失败，请稍后再试')
        }
      })
    },
    passwordNew (e) {
      if (!this.password) {
        this.$toast.text('请输入密码')
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.phoneNumber)) {
        this.$toast.text('请输入正确的手机号')
        return
      }
      if (!this.code) {
        this.$toast.text('请输入手机验证码')
        return
      }
      api.resetPassword({
        phoneNumber: this.phoneNumber,
        password: this.password,
        code: this.code
      }).then(res => {
        if (res.code === 200) {
          this.$toast.text('设置成功')
          this.type = 'login'
        } else {
          this.$toast.text(res.message || '登录失败，请稍后再试')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.account-com {
  .nut-dialog {
    max-width: 520px;
    // max-width: 1000px;
    position: relative;
    .nut-textinput {
      margin-top: 20px;
      padding: 0 20px;
    }
    .nut-textinput-label {
      text-align: left;
      width: 58px;
    }
    .register {
      margin-top: 8px;
      text-align: right;
      padding: 0 20px;
    }
    .register-tips {
      margin: 8px 20px -4px;
      text-align: left;
      color: #409EFF;
    }
    .action {
      margin-top: 20px;
      .login {
        display: block;
        margin: 0 auto;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #409EFF;
        color: #fff;
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .icon-close {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
  }
  #codeLine{
    width: 100%!important;
  }
}
</style>
